import i18next from "i18next";
import * as Yup from "yup";
import { generalValidationMessage } from "../config/appConfig";

export const Validation = {};

export const calenderValidation = () => {
  const translatedGeneralValidationMessage = `${i18next.t(
    generalValidationMessage
  )}`;
  return Yup.date().required(translatedGeneralValidationMessage);
};

export const datePickerRegex = /[0-9-0]/;

export const licencePlateRegx =
  /(\w{2}-\d{2}-\d{2})|(\d{2}-\d{2}-\w{2})|(\d{2}-\w{2}-\d{2})|(\w{2}-\d{2}-\w{2})|(\w{2}-\w{2}-\d{2})|(\d{2}-\w{2}-\w{2})|(\d{2}-\w{3}-\d{1})|(\d{1}-\w{3}-\d{2})|(\w{2}-\d{3}-\w{1})|(\w{1}-\d{3}-\w{2})|(\w{3}-\d{2}-\w{1})|(\d{1}-\w{2}-\d{3})|(\d{3}-\w{2}-\d{1})|(\w{1}-\d{2}-\w{3})/;

export const licencePlateReg = /^[A-A]{2}-\d{4}$/;


export const licencePlateValidation = (isRequired = true) => {
  const translatedGeneralValidationMessage = `${i18next.t(
    generalValidationMessage
  )}`;
  if (isRequired) {
    return Yup.string(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage)
      .test("len", translatedGeneralValidationMessage, (val) => {
        const isMatchWithoutSpacialChar = val.match(/^[a-zA-Z0-9]{6}$/);
        return (
          isMatchWithoutSpacialChar || (val.length === 8 && licencePlateRegx)
        );
      });
  } else {
    return Yup.string(translatedGeneralValidationMessage);
  }
};
